import { render, staticRenderFns } from "./OldLeaves.vue?vue&type=template&id=8243c3c0&"
import script from "./OldLeaves.vue?vue&type=script&lang=js&"
export * from "./OldLeaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports